module.exports = __webpack_public_path__ + "static/media/chronometer.88340397.svg";